import { trackReplyTemplateCreateSuccess } from '../../containers/ReplyTemplateModalContainer/tracking';
import { currentChatOpponentIdSelector, currentOpenChatIDSelector } from '../../selectors';
import { createUserReplyTemplatePublic } from '../../services';
import { showAlert } from '../../slices/alertSlice';
import { createAppAsyncThunk } from '../../store/createAppAsyncThunk';
import { EAlert } from '../../types/alert';

import type {
  ICreateUserReplyTemplateRequest,
  ICreateUserReplyTemplatesListResponse,
} from '../../types/replyTemplates';

export const createUserReplyTemplateThunk = createAppAsyncThunk<
  ICreateUserReplyTemplatesListResponse,
  ICreateUserReplyTemplateRequest,
  { rejectValue: string }
>('chats/createUserReplyTemplateThunk', async (parameters: ICreateUserReplyTemplateRequest, _thunkApi) => {
  const { fulfillWithValue, rejectWithValue, extra: context, dispatch, getState } = _thunkApi;

  const state = getState();
  const { replyTemplates } = state;

  try {
    const response = await createUserReplyTemplatePublic(context, parameters);

    const successMessage = replyTemplates.isOnboardingEnabled
      ? 'Готово! Нажмите на шаблон — подставим его в поле ввода, чтобы дописать или сразу отправить.'
      : 'Шаблон успешно создан!';

    dispatch(showAlert({ message: successMessage, type: EAlert.Info }));

    const opponentId = currentChatOpponentIdSelector(state);
    const chatId = currentOpenChatIDSelector(state);

    trackReplyTemplateCreateSuccess({ chatId, opponentId, replyTemplateId: response.createdReplyTemplateId });

    return fulfillWithValue(response);
  } catch (e) {
    dispatch(showAlert({ message: 'Не удалось создать шаблон' }));

    if (e?.statusCode === 400) {
      return rejectWithValue(e instanceof Error ? e.message : String(e));
    }

    return rejectWithValue('');
  }
});
